import { UPLOAD_PROVIDERS } from '@disco/services/upload/constants'

import React, { useEffect, useRef } from 'react'
import type { UploadProvider } from 'types/upload'
import type { AbortProviderOpen } from 'components/common/upload/config'
import providerConfig from 'components/common/upload/config'
import { Flex } from 'components/ds'
import ProviderButton from './provider-button'
type Props = {
  onFilesSelect: (files: any, provider: UploadProvider) => void
}

const UploadProviderButtons = ({ onFilesSelect }: Props): React.ReactNode => {
  const abort = useRef<AbortProviderOpen | null | undefined>(undefined)

  const handleClick = (provider: UploadProvider) => {
    const config = providerConfig[provider.id]
    if (!config || !config.open) return
    abort.current = config.open(files => {
      onFilesSelect(files, provider)
    })
  }

  useEffect(() => {
    return () => {
      if (abort.current) {
        abort.current()
      }
    }
  }, [])
  return (
    <Flex gap="2" wrap="wrap" justify="center">
      {UPLOAD_PROVIDERS.map(provider => (
        <ProviderButton
          key={provider.id}
          provider={provider}
          onClick={handleClick}
        />
      ))}
    </Flex>
  )
}

export default UploadProviderButtons
